module.exports = __webpack_public_path__ + "img/30.830fc265.jpg";